import { Box, Chip, Typography } from '@mui/material'
import GameTypeIcon from 'Components/_common/GameTypeIcon'
import { useContestWinnersListQuery } from 'Queries/Contests'
import { useCategoryName, usePlayersCountName } from 'Queries/Dictionaries'
import { useMemo } from 'react'
import { navigateToContestPage } from 'Scenes/navigators'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import { getDayMonth } from '../../utils/date-utils'
import WinnersView from './WinnersView'

const WinnersContestAdaptor = ({ event }) => {
  const dateOfFinal = getDayMonth(event?.time_end)
  const categoryName = useCategoryName(event?.category_id)
  const mapPlayers = usePlayersCountName(event?.players_count_id)

  const { data: winners = [] } = useContestWinnersListQuery(event?.id)
  const communityWinner = useMemo(() => winners.find((obj) => obj?.is_community === true), [winners])

  const readablePrize = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(event?.prize_value)

  const fixPositionCommunityVote = useMemo(() => {
    if (!!communityWinner) {
      const communityWinnerIndex = winners.indexOf(communityWinner)
      if (communityWinnerIndex === 3) return winners

      winners.splice(communityWinnerIndex, 1)
      winners.splice(3, 0, communityWinner)
    }
    return winners
  }, [winners, communityWinner])

  return (
    <WinnersView
      maps={fixPositionCommunityVote}
      isWithBottomRowChip
      isWithCommunityFavorite={!!communityWinner}
      onClickAll={() => navigateToContestPage(event?.id)}
      mobileOnClick={() => navigateToContestPage(event?.id)}
      mobileOnClickTitle="View all the winners"
      footer={
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          alignItems="end"
          marginTop="24px"
        >
          <Box>
            <Chip
              label={
                <Typography
                  variant="overline"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '7px 14px',
                  }}
                >
                  <FAIcon
                    iconClassName={FA_ICONS.TROPHY}
                    iconFontSize={16}
                  />
                  MAP CONTEST
                </Typography>
              }
              style={{ background: 'rgba(0, 0, 0, 0.25)' }}
            />
            <Box
              marginTop="16px"
              display="flex"
              alignItems="center"
              gap="15px"
            >
              <GameTypeIcon
                gameType={categoryName}
                size="large"
                style={{ width: '40px', height: '40px' }}
              />
              <Typography variant="h1">{event?.title}</Typography>
              <Typography variant="h3">{mapPlayers}</Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            height="64px"
          >
            <Box
              width="80px"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              backgroundColor="rgba(0, 0, 0, 0.25)"
              borderRadius="20px"
              padding="10px"
              sx={{ backdropFilter: 'blur(4px)' }}
            >
              <Typography
                variant="body2bold"
                color="text.primary"
              >
                {dateOfFinal}
              </Typography>
              <Typography
                variant="subtitle2"
                color="text.tertiary"
                lineHeight="24px"
              >
                Final
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              backgroundColor="rgba(0, 0, 0, 0.25)"
              borderRadius="20px"
              marginLeft="8px"
              padding="10px"
              sx={{ backdropFilter: 'blur(4px)' }}
            >
              <Chip
                label={
                  <Typography
                    variant="body2bold"
                    color="text.primary"
                  >
                    {readablePrize}
                  </Typography>
                }
                sx={{ backgroundColor: 'secondary.main', padding: '0 10px', height: '24px' }}
              />
              <Typography
                variant="subtitle2"
                color="text.tertiary"
                lineHeight="24px"
              >
                Prize pool
              </Typography>
            </Box>
          </Box>
        </Box>
      }
    />
  )
}

export default WinnersContestAdaptor
